import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

import OrderBook from 'components/SideBar.js/OrderBook';
import PeersMulti from 'components/SideBar.js/PeersMulti';
import ValuationMethodo from 'components/SideBar.js/ValuationMethodo';
import Recent from 'components/SideBar.js/Recent';
import Feed from './components/Feed';

import SubHeader from './components/SubHeader';

const useStyles = makeStyles((theme) => ({
  grid: {
    height: '100%'
  },
  paper: {
    padding: '50px'
  },
  fullWidth: {
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.34)',
    zIndex: 10,
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    height: '200px',
    display: 'flex'
  },
  title: {
    fontFamily: 'PT Sans-serif',
    color: '#001E41',
    fontWeight: 'bold',
    fontSize: 22,
    marginLeft: '1rem'
  },
  subTitle: {
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#002380'
  },
  feedContainer: {
    display: 'flex',
    margin: '0 auto',
    '@media (min-width:1440px)': {
      width: '65%'
    }
  },
  sideBar: {
    marginLeft: 'auto',
    position: 'sticky',
    top: -100,
    overflow: 'scroll',
    width: 450,
    minWidth: 450,
    height: '100vh',
    maxWidth: 550,
    backgroundColor: '#FFF',
    padding: '14rem 1rem',
    '-webkit-box-shadow': '4px 2px 9px -5px rgba(0,0,0,0.68)',
    '-moz-box-shadow': '4px 2px 9px -5px rgba(0,0,0,0.68)',
    boxShadow: '4px 2px 9px -5px rgba(0,0,0,0.68)'
  }
}));

const Home = (props) => {
  const classes = useStyles();

  return (
    <>
      <SubHeader />
      <div style={{display: 'flex'}}>
        <div className={classes.sideBar}>
          <h6 className={classes.title}>Key Metrics</h6>
          <OrderBook />
          <PeersMulti />
          <ValuationMethodo />
          <Recent />
        </div>
        <Feed/>
      </div>
      
    </>
  );
};

export default withRouter(Home);
